import IsAuthenticated from "@/permissions/IsAuthenticated";
import HasGroupAccess from "@/permissions/HasGroupAccess";
import {
  GROUP_NAME,
  HOME_ROUTE_NAME,
  TITLE
} from "@/modules/julho_14/settings";

const hasGroupAccess = HasGroupAccess(GROUP_NAME);
const isAuthenticated = IsAuthenticated();

export default [
  {
    path: "/14-julho",
    name: HOME_ROUTE_NAME,
    meta: {
      title: TITLE,
      permissions: [isAuthenticated, hasGroupAccess]
    },
    component: () =>
      import(
        /* webpackChunkName: "julho_14" */ "@/modules/julho_14/views/Julho14.vue"
      ),
    redirect: {
      name: `${HOME_ROUTE_NAME}.alerts`
    },
    children: [
      {
        path: "alerts",
        name: `${HOME_ROUTE_NAME}.alerts`,
        meta: {
          title: "Alertas"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "@/modules/julho_14/views/Alerts.vue"
          )
      },
      {
        path: "reservoir",
        name: `${HOME_ROUTE_NAME}.reservoir`,
        meta: {
          title: "Nível Reservatório"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "@/modules/julho_14/views/Reservoir.vue"
          )
      },
      {
        path: "prisms",
        name: `${HOME_ROUTE_NAME}.prisms`,
        meta: {
          title: "Prismas Virtuais"
        },
        component: () =>
          import(/* webpackChunkName: "julho_14" */ "./views/Prisms.vue")
      },
      {
        path: "triaxial-measurers",
        name: `${HOME_ROUTE_NAME}.triaxial-joints`,
        meta: {
          title: "Medidores Triortogonais"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "@/modules/julho_14/views/TriaxialJoint"
          )
      },
      {
        path: "sensors",
        name: `${HOME_ROUTE_NAME}.sensors`,
        meta: {
          title: "Sensors"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "@/modules/julho_14/views/Sensors.vue"
          )
      },
      {
        path: "visualization",
        name: `${HOME_ROUTE_NAME}.visualization`,
        meta: {
          title: "Visualização"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "@/modules/julho_14/views/Visualization"
          )
      }
    ]
  },
  {
    path: "/14-julho/simulator",
    name: `${HOME_ROUTE_NAME}.simulator`,
    meta: {
      title: "Simulador",
      permissions: [isAuthenticated, hasGroupAccess]
    },
    component: () =>
      import(/* webpackChunkName: "julho_14" */ "./views/Simulator.vue"),
    redirect: {
      name: `${HOME_ROUTE_NAME}.simulator.input`
    },
    children: [
      {
        path: "input",
        name: `${HOME_ROUTE_NAME}.simulator.input`,
        meta: {
          title: "Dados de entrada"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "./views/simulator/InputData"
          )
      },
      {
        path: "calculate",
        name: `${HOME_ROUTE_NAME}.simulator.calculate`,
        meta: {
          title: "Calcular"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "./views/simulator/Calculate.vue"
          )
      },
      {
        path: "output",
        name: `${HOME_ROUTE_NAME}.simulator.output`,
        meta: {
          title: "Resultados"
        },
        component: () =>
          import(
            /* webpackChunkName: "julho_14" */ "./views/simulator/OutputData"
          )
      }
    ]
  }
];
